import registerRoutes from './routes';
import configureTags from './tags/index';

import createEnquiryFactory from './services/enquiries/createEnquiry';
import getVehicleDetailsCheckFactory from './services/enquiries/getVehicleDetailsCheck';
// import getDealersFactory from './services/enquiries/getDealers';
import getEnquiries from './services/enquiries/getEnquiries';
import getVehicleDetailsFactory from './services/vehicles/getVehicleDetails';
import getTasksFactory from './services/tasks/getTasks';
import getVehicleFactory from './services/vehicles/getVehicle';
import completeTaskFactory from './services/tasks/completeTask';
import updateMileageExcludedStatusFactory from './services/mileages/updateMileageExcludedStatus';
import getKeeperDetailsFactory from './services/keepers/getKeeperDetails';
import openKeeperModalFactory from './services/keepers/openKeeperModal';
import updateKeeperDetailsFactory from './services/keepers/updateKeeperDetails';
import getEnquiriesProgressFactory from './services/enquiries/getEnquiriesProgress';
import discrepancyResolvedStateFactory from './services/discrepancies/discrepancyResolvedState';
import addNoteFactory from './services/notes/addNote';
import openAddNoteModalFactory from './services/notes/openAddNoteModal';
import openListNoteModalFactory from './services/notes/openListNoteModal';
import getDealerEnquiries from './services/enquiries/getDealerEnquiries';
import openDiscrepancyResolveStateModalFactory from './services/discrepancies/openDiscrepancyResolveStateModal';
import updateDiscrepancyResolvedStateFactory from './services/discrepancies/updateDiscrepancyResolvedState';
import openCloseInvestigationModalFactory from './services/investigations/openCloseInvestigationModal';
import openEditVehicleModalFactory from './services/vehicles/openEditVehicleModal';
import updateVehicleFactory from './services/vehicles/updateVehicle';
import takeTaskOwnershipFactory from './services/tasks/takeTaskOwnership';
import takeOverTaskOwnershipFactory from './services/tasks/takeOverTaskOwnership';
import applyTaskOwnershipStateFactory from './services/tasks/applyTaskOwnershipState';
import openAddMileageModalFactory from './services/mileages/openAddMileageModal';
import addMileageFactory from './services/mileages/addMileage';
import openEditMileageModalFactory from './services/mileages/openEditMileageModal';
import openCreateLetterModalFactory from './services/createLetter/openCreateLetterModal';
import createKeeperConfirmationLetterFactory from './services/createLetter/createKeeperConfirmationLetter';
import createDealerConfirmationLetterFactory from './services/createLetter/createDealerConfirmationLetter';
import editMileageFactory from './services/mileages/editMileage';
import updateBillingDetailsFactory from './services/enquiries/updateBillingDetails';
import createKeeperFactory from './services/keepers/createKeeper';
import openCreateKeeperModelFactory from './services/keepers/openCreateKeeperModel';
import keeperMoveFactory from './services/keepers/keeperMove';
import keeperDeleteFactory from './services/keepers/keeperDelete';
import keeperContactFactory from './services/keepers/keeperContact';
import tasksListDirective from './directives/tasksList';
import enquiriesProgressDirective from './directives/enquiriesProgress';
import enquiryProgressDirective from './directives/enquiryProgress';
import statusIconDirective from './directives/statusIcon';

import vehicleChartDirective from './directives/vehicleChart';

export default function (app) {
    app.factory('createEnquiry', createEnquiryFactory);
    app.factory('getVehicleDetailsCheck', getVehicleDetailsCheckFactory);
    // app.factory('getDealers', getDealersFactory);
    app.factory('getEnquiries', getEnquiries);
    app.factory('getVehicleDetails', getVehicleDetailsFactory);
    app.factory('getTasks', getTasksFactory);
    app.factory('getVehicle', getVehicleFactory);
    app.factory('completeTask', completeTaskFactory);
    app.factory('updateMileageExcludedStatus', updateMileageExcludedStatusFactory);
    app.factory('getKeeperDetails', getKeeperDetailsFactory);
    app.factory('openKeeperModal', openKeeperModalFactory);
    app.factory('updateKeeperDetails', updateKeeperDetailsFactory);
    app.factory('getEnquiriesProgress', getEnquiriesProgressFactory);
    app.factory('discrepancyResolvedState', discrepancyResolvedStateFactory);
    app.factory('openAddNoteModal', openAddNoteModalFactory);
    app.factory('addNote', addNoteFactory);
    app.factory('openListNoteModal', openListNoteModalFactory);
    app.factory('getDealerEnquiries', getDealerEnquiries);
    app.factory('openDiscrepancyResolveStateModal', openDiscrepancyResolveStateModalFactory);
    app.factory('updateDiscrepancyResolvedState', updateDiscrepancyResolvedStateFactory);
    app.factory('openCloseInvestigationModal', openCloseInvestigationModalFactory);
    app.factory('openEditVehicleModal', openEditVehicleModalFactory);
    app.factory('updateVehicle', updateVehicleFactory);
    app.factory('takeTaskOwnership', takeTaskOwnershipFactory);
    app.factory('takeOverTaskOwnership', takeOverTaskOwnershipFactory);
    app.factory('applyTaskOwnershipState', applyTaskOwnershipStateFactory);
    app.factory('openAddMileageModal', openAddMileageModalFactory);
    app.factory('addMileage', addMileageFactory);
    app.factory('openEditMileageModal', openEditMileageModalFactory);
    app.factory('openCreateLetterModal', openCreateLetterModalFactory);
    app.factory('createKeeperConfirmationLetter', createKeeperConfirmationLetterFactory);
    app.factory('createDealerConfirmationLetter', createDealerConfirmationLetterFactory);
    app.factory('editMileage', editMileageFactory);
    app.factory('updateBillingDetails', updateBillingDetailsFactory);
    app.factory('createKeeper', createKeeperFactory);
    app.factory('openCreateKeeperModel', openCreateKeeperModelFactory);
    app.factory('keeperMove', keeperMoveFactory);
    app.factory('keeperDelete', keeperDeleteFactory);
    app.factory('keeperContact', keeperContactFactory);
    app.directive('tasksList', tasksListDirective);
    app.directive('enquiriesProgress', enquiriesProgressDirective);
    app.directive('enquiryProgress', enquiryProgressDirective);
    app.directive('statusIcon', statusIconDirective);

    app.directive('vehicleChart', vehicleChartDirective);

    configureTags(app);

    registerRoutes(app);
}



// WEBPACK FOOTER //
// ./Client/app/tasks/index.js